import { ErrorResponse, fetchClient } from "@request/client";

type TokenResponse =
  | {
      idToken: string;
      refreshToken: string;
    }
  | ErrorResponse;

type AuthResponse =
  | TokenResponse
  | {
      idToken: string;
      qrCodeUrl: string;
      sharedSecretKey: string;
      sessionInfo: string;
    };

type RegisterResponse =
  | {
      message: string;
    }
  | ErrorResponse;

type RefreshTokenResponse =
  | {
      access_token: string;
      expires_in: string;
      token_type: string;
      refresh_token: string;
      id_token: string;
      user_id: string;
      project_id: string;
    }
  | ErrorResponse;

export type AuthForm = {
  email: string;
  password: string;
  code?: string;
};

export type EnrollmentOtpForm = {
  code: string;
};

export type RegisterForm = Pick<AuthForm, "email" | "password"> & {
  password_confirmation: string;
};

export const auth = async (data: AuthForm) => {
  try {
    const response = await fetchClient<AuthResponse>({
      url: "api/v1/auth/login",
      method: "POST",
      data,
    });

    if ("error" in response) {
      throw new Error(response.details);
    }

    return response;
  } catch (error) {
    console.error("Authentication failed:", error);
    throw error;
  }
};

export const enrollmentOtp = async (
  data: EnrollmentOtpForm & {
    accessToken: string;
    sessionInfo: string;
  }
) => {
  try {
    const response = await fetchClient<TokenResponse>({
      url: "api/v1/auth/enrollment:finish",
      method: "POST",
      data: {
        code: data.code,
        IdToken: data.accessToken,
        sessionInfo: data.sessionInfo,
      },
      headers: { Authorization: `Bearer ${data.accessToken}` },
    });

    if ("error" in response) {
      throw new Error(response.details);
    }

    return response;
  } catch (error) {
    console.error("Enrollment otp failed:", error);
    throw error;
  }
};

export const refreshToken = async (refreshToken: string) => {
  try {
    const response = await fetchClient<RefreshTokenResponse>({
      url: "api/v1/auth/refresh",
      method: "POST",
      data: {
        refresh_token: refreshToken,
      },
    });

    if ("error" in response) {
      throw new Error(response.details);
    }

    return response;
  } catch (error) {
    console.error("Refresh token failed:", error);
    throw error;
  }
};

export const register = async (data: RegisterForm) => {
  try {
    const response = await fetchClient<RegisterResponse>({
      url: "api/v1/auth/registration",
      method: "POST",
      data: {
        email: data.email,
        password: data.password,
      },
    });

    if ("error" in response) {
      throw new Error(response.details);
    }

    return response;
  } catch (error) {
    console.error("Registration failed:", error);
    throw error;
  }
};
